import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const SubscriptionLmPattern: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/subscription-lm-pattern.excalidraw"
    title="Subscription + LM Course Pattern"
    subtitle="How to sell software as a subscription with automated onboarding via linked LM courses"
  />
);

export default SubscriptionLmPattern;
